import { combineReducers, configureStore, Action } from '@reduxjs/toolkit';
import { ThunkAction } from 'redux-thunk';

import auth, { actions as authActions } from './services/auth';
import users from './services/users';
import userChats from './services/userChats';
import chatMessages from './services/chatMessages';
import chats from './services/chats';
import support from './services/support';
import stats from './services/stats';
import photos from './services/photos';
import reportedUsers from './services/reportedUsers';
import userMatches from './services/userMatches';
import userSwipes from './services/userSwipes';
import userGifts from './services/userGifts';
import userTransactions from './services/userTransactions';
import userReports from './services/userReports';


const rootReducer = combineReducers({
  auth,
  users,
  userChats,
  chatMessages,
  chats,
  support,
  stats,
  photos,
  reportedUsers,
  userMatches,
  userSwipes,
  userGifts,
  userTransactions,
  userReports,
});

export type RootState = ReturnType<typeof rootReducer>;

export type AppThunk<T = void> = ThunkAction<T, RootState, null, Action<string>>;

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

// if (process.env.NODE_ENV === 'development' && module.hot) {
//   module.hot.accept('./store', () => {
//     store.replaceReducer(rootReducer);
//   });
// }

store.dispatch(authActions.init() as any);

export type AppDispatch = typeof store.dispatch;
export default store;